import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fnpCashTitle: "fnpCash",
  usedCashText: "You used",
  availableBalance: "",
  usableBalance: 0,
  fnpChipText: "New",
  fnpCashCheckboxState: null,
  defaultFnpCashSelected: "N",
  fnpCashWithGiftCoupon: true,
};

const FnpCashSlice = createSlice({
  name: "fnpCash",
  initialState,
  reducers: {
    requestToFetchFnpCashBalance: () => {},
    requestToFetchFnpLabel: () => {},

    setFnpCashLabel: (state, action) => {
      state.fnpCashTitle = action.payload?.wallet?.label?.fnpcash;
      state.usedCashText = action.payload?.wallet?.label?.youused;
      state.fnpChipText = action.payload?.wallet?.label?.new;
      state.defaultFnpCashSelected = action.payload?.wallet?.fnpWalletSelected;
      state.fnpCashWithGiftCoupon = action.payload?.fnpcashwithgiftcoupon;
    },

    setFnpCashBalance: (state, action) => {
      state.availableBalance = action.payload?.response?.balance;
      state.usableBalance = action.payload?.response?.usableBalance;
      state.programs = action.payload?.response?.programs;
    },

    isFnpCashCheckboxChecked: (state, action) => {
      state.fnpCashCheckboxState = action.payload;
    },
  },
});

export const {
  setFnpCashLabel,
  setFnpCashBalance,
  requestToFetchFnpCashBalance,
  requestToFetchFnpLabel,
  isFnpCashCheckboxChecked,
} = FnpCashSlice.actions;

export default FnpCashSlice.reducer;
